package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korge.view.*
import component.*
import kotlinx.coroutines.channels.*

class OtherPlayerDisconnectedSystem(
    private val physicWorld: org.jbox2d.dynamics.World = World.inject(),
    private val camera: Camera = World.inject()
) : IteratingSystem(family { all(OtherPlayerComponent) }) {

    private val playersToDestroy = Channel<Int>(capacity = 5)

    private var playerToDestroy: Int? = null

    suspend fun onPlayerDisconnect(playerId: Int) {
        playersToDestroy.trySend(playerId)
    }

    override fun onTick() {
        playerToDestroy = playersToDestroy.tryReceive().getOrNull()
        if (playerToDestroy != null) {
            super.onTick()
        }
    }

    override fun onTickEntity(entity: Entity) {
        val otherPlayerComponent = entity[OtherPlayerComponent]
        if (otherPlayerComponent.id == playerToDestroy) {
            entity.remove()
        }
    }
}
